angular.module('leave', ['core', 'files', 'document'])
    .factory('Leave', function ($resource) {
        return $resource('/crm/api/leave/:id', {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/leave/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/leave/table-statistics'},
            acceptanceTable: {method: 'GET', isArray: false, url: '/crm/api/leave/table-acceptance'},
            acceptanceTableStatistics: {method: 'GET', isArray: false, url: '/crm/api/leave/table-acceptance-statistics'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            action: {method: 'PUT', url: '/crm/api/leave/:id/:action', params: {id: "@id", action: "@action"}}
        });
    })
    .component('leaveStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span class="label label-default leave-status {{$ctrl.status}}">{{ 'leave.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
    .service('LeaveService', function ($rootScope, modals, Leave) {
        this.statuses = () => ['PENDING', 'PENDING_REVOKE', 'ACCEPTED', 'REJECTED', 'REVOKED', 'CANCELLED']
        this.add = () => {
            return modals.open('app/leave/edit-modal.html', 'LeaveEditController', {}, {size: "md"}, "$ctrl")
        }
        this.open = (id) => {
            return modals.open('app/leave/show-modal.html', 'LeaveShowController', {id: id}, {size: "md"}, "$ctrl")
        }
        this.openOfEvent = (event) => {
            return modals.open('app/leave/show-modal-event.html', 'LeaveShowEventController', {event: event}, {size: "md"}, "$ctrl")
        }
        this.edit = (id) => {
            return modals.open('app/leave/edit-modal.html', 'LeaveEditController', {id: id}, {size: "md"}, "$ctrl")
        }
        this.statistics = (data) => {
            return modals.open('app/leave/statistics-modal.html', 'LeaveStatisticsController', data, {size: "lg"}, "$ctrl")
        }
        this.delete = item => {
            return modals.confirmDelete(item.type.name, () => Leave.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('leave.deleted')))
        }
        this.cancelAsManager = item => {
            return modals.confirm("Czy na pewno chcesz anulować " + item.type.name + "?", () => {
                return Leave.action({id: item.id, action: "cancel-manager"}).$promise.then(() => $rootScope.$broadcast('leave.updated'));
            })
        }
        this.action = (id, action) => {
            return Leave.action({id: id, action: action}).$promise.then(() => $rootScope.$broadcast('leave.updated'))
        }
        this.countNotWorkingDays = (startDate, endDate) => {
            let start = new Date(startDate);
            let end = new Date(endDate);
            // let daysOffArray = daysOff ? daysOff.map(dayOff => new Date(dayOff)) : [];

            let daysOffCount = 0;
            while (start <= end) {
                let day = start.getDay();
                // if (day === 0 || day === 6 || daysOffArray.some(dayOff => day === dayOff.getDay())) {
                if (day === 0 || day === 6) {
                    daysOffCount++;
                }
                start.setDate(start.getDate() + 1);
            }
            return daysOffCount;
        }
        this.calculateDays = (startDate, endDate) => {
            let start = new Date(startDate);
            let end = new Date(endDate);
            const diffInMilliseconds = end - start;
            const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
            return Math.floor(diffInDays) + 1;
        }
    })
    .controller('LeaveEditController', function ($scope, $rootScope, $uibModalInstance, Leave, data, LeaveService, LeaveDayOff) {
        this.$onInit = () => {
            if (data.id != null)
                Leave.get({id: data.id}).$promise.then(item => this.item = item)
            else
                this.item = {}
        }

        this.pickUser = () => {
            this.item.user = null
        }

        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = Leave.update(this.item).$promise
            } else {
                promise = Leave.save(this.item).$promise
            }
            return promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast('leave.updated')
            })
        }

        this.onPeriodChanged = () => {
            this.item.numberOfDays = null
            if(this.isEndDateDisabled()){
                this.item.endDate = this.item.startDate
                this.item.numberOfDays = 1
                return;
            }
            if (!this.item.startDate || !this.item.endDate)
                return;

            LeaveDayOff.queryCount({start: this.item.startDate, end: this.item.endDate}).$promise
                .then(daysOff => {
                    this.item.numberOfDays = LeaveService.calculateDays(this.item.startDate, this.item.endDate) - LeaveService.countNotWorkingDays(this.item.startDate, this.item.endDate) - daysOff.count
                })
                .catch(error => {
                    this.item.startDate = null
                    this.item.endDate = null
                    this.item.numberOfDays = null
                })
        }

        this.onTypeChanged = () => {
            this.item.billing = this.item.type.billing
            this.onPeriodChanged()
        }

        this.isEndDateDisabled = () => {
            return this.item.type.category === 'COMPENSATORY_DAY_OFF'
        }

        this.isCompensatoryDayRequired = () => {
            return this.item.type.category === 'COMPENSATORY_DAY_OFF'
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('LeaveShowController', function ($scope, $rootScope, $uibModalInstance, Leave, data, LeaveService, Principal) {
        this.LeaveService = LeaveService
        this.$onInit = () => {
            Leave.get({id: data.id}).$promise.then(item => {
                this.item = item
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
                this.isPending = ['PENDING', 'PENDING_REVOKE'].includes(item.status)
                this.isAccepted = item.status === 'ACCEPTED'
                Principal.currentUser().then(user => {
                    this.isMine = item.user.id === user.id
                })
            })
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
        $scope.$on('leave.updated', () => this.$onInit())
        $scope.$on('leave.deleted', () => this.cancel())
    })
    .controller('LeaveShowEventController', function ($uibModalInstance, data, LeaveService) {
        this.LeaveService = LeaveService
        this.$onInit = () => {
            this.item = data.event
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
    .controller('LeaveStatisticsController', function ($scope, $rootScope, $uibModalInstance, Leave, data, LeaveService, LeaveTypeService, Principal) {
        this.LeaveService = LeaveService
        this.$onInit = () => {
            this.data = data
            this.categories = LeaveTypeService.categories()
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
        $scope.$on('leave.updated', () => this.$onInit())
        $scope.$on('leave.deleted', () => this.cancel())
    })
    .controller('LeaveShowFullController', function ($window, $state, $scope, $stateParams, $rootScope, Leave, LeaveService, Principal) {
        this.LeaveService = LeaveService
        this.Principal = Principal

        this.$onInit = () => {
            this.load($stateParams.id)
        }

        this.load = id => {
            Leave.get({id: id}).$promise.then(item => {
                this.item = item
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
                this.isPending = ['PENDING', 'PENDING_REVOKE'].includes(item.status)
                this.isAccepted = item.status === 'ACCEPTED'
                Principal.currentUser().then(user => {
                    this.isMine = item.user.id === user.id
                })
            })
        }

        this.cancel = () => $window.history.back()
        this.canCancel = () => $window.history.length > 1

        $scope.$on('leave.updated', () => {
            $rootScope.$broadcast('document.comments.reload', this.item.id)
            this.$onInit();
        })
        $scope.$on('leave.deleted', () => {
            if(this.canCancel()){
                this.cancel()
            }
            else{
                $state.go('leaveList')
            }
        })
        $scope.$on("file.saved", () => this.$onInit())
    })
    .component('leaveList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/leave/list.html',
        controller: function ($scope, $state, $stateParams, Leave, LeaveService) {
            this.LeaveService = LeaveService
            this.reset = () => this.filters = {filter: this.filters.filter}

            this.onTypeChanged = ($type) => {
                this.filters.type = $type
                $state.go($state.current, this.filters, {inherit: false, reload: true, notify: false});
            }

            this.refresh = () => {
                Leave.table($stateParams).$promise.then(page => this.page = page)
                Leave.tableStatistics($stateParams).$promise.then(statistics => this.statistics = statistics)
            }

            $scope.$on('leave.updated', () => this.refresh())
            $scope.$on('leave.deleted', () => this.refresh())
        }
    })
    .component('leaveAcceptanceList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/leave/list.html',
        controller: function ($scope, $stateParams, Leave, LeaveService) {
            this.LeaveService = LeaveService
            this.reset = () => this.filters = {filter: this.filters.filter}

            this.refresh = () => {
                Leave.acceptanceTable($stateParams).$promise.then(page => this.page = page)
                Leave.acceptanceTableStatistics($stateParams).$promise.then(statistics => this.statistics = statistics)
            }

            $scope.$on('leave.updated', () => this.refresh())
            $scope.$on('leave.deleted', () => this.refresh())
        }
    })
    .run(function (NavbarLeftMenu, Principal, $http, $interval, $rootScope) {
        const menuPath = '/leave?status=PENDING&status=PENDING_REVOKE'

        function loadCounter() {
            Principal.identity().then(account => {
                let auth = Principal.hasAnyAuthority(['ROLE_LEAVE_ACCEPTANCE'])
                if (!auth) {
                    NavbarLeftMenu.updateCount(menuPath, 0)
                    return;
                }

                $http.get("/crm/api/leave/table-acceptance?filter=acceptance&status=PENDING&status=PENDING_REVOKE").then(response => {
                    let statistics = response.data
                    NavbarLeftMenu.updateCount(menuPath, statistics.fullListSize)
                }).catch(() => {
                    NavbarLeftMenu.updateCount(menuPath, 0)
                })
            })
        }

        NavbarLeftMenu.add({
            authorities: "ROLE_LEAVE_MODULE",
            path: menuPath,
            ico: "fa fa-fw fa-futbol-o",
            name: 'leave.menu',
            order: 53
        });

        $rootScope.$on("leave.updated", () => loadCounter())
        $rootScope.$on("authenticationChanged", () => loadCounter())

        let intPromise = null;

        function initAutoRefresh() {
            $interval.cancel(intPromise)
            loadCounter()
            intPromise = $interval(initAutoRefresh, 60000)
        }

        this.$onDestroy = () => $interval.cancel(intPromise);

        initAutoRefresh()
    })
    .config(function ($stateProvider) {
        $stateProvider.state('leaveList', {
            parent: 'app',
            url: '/leave?{page:int}&{size:int}&sort&search&startDate&endDate&status&type&user&manager&filter&compensatoryStart&compensatoryEnd',
            data: {
                authorities: ['ROLE_LEAVE_MODULE']
            },
            params: {
                status: {array: true, value: ['PENDING', 'PENDING_REVOKE'], squash: false},
                filter: {value: 'my', squash: true},
                type: {array: true, type: "int"}
            },
            views: {
                'content@': 'leaveList'
            },
            resolve: {
                statistics: (Leave, $stateParams) => Leave.tableStatistics($stateParams).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (Leave, $stateParams) => Leave.table($stateParams).$promise
            }
        })
    })
    .config(function ($stateProvider) {
        $stateProvider.state('leaveAcceptanceList', {
            parent: 'app',
            url: '/leave-acceptance?{page:int}&{size:int}&sort&search&startDate&endDate&status&type&user&manager&filter&compensatoryStart&compensatoryEnd',
            data: {
                authorities: ['ROLE_LEAVE_ACCEPTANCE']
            },
            params: {
                status: {array: true, value: ['PENDING', 'PENDING_REVOKE'], squash: false},
                filter: {value: 'acceptance', squash: true},
                type: {array: true, type: "int"}
            },
            views: {
                'content@': 'leaveAcceptanceList'
            },
            resolve: {
                statistics: (Leave, $stateParams) => Leave.acceptanceTableStatistics($stateParams).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (Leave, $stateParams) => Leave.acceptanceTable($stateParams).$promise
            }
        })
        $stateProvider.state('leaveShowFull', {
            parent: 'app',
            url: '/leave/{id}',
            data: {
                authorities: ['ROLE_LEAVE_MODULE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/leave/show.html',
                    controller: 'LeaveShowFullController',
                    controllerAs: '$ctrl'
                }
            },
        })
    })
